<template>
	<router-view :key="$route.fullPath"></router-view>
</template>

<script>
// import {mapGetters} from "vuex";
// import  {InventoryFormGetters} from "../../store/getters";

export default {
	name: 'Inventory',
	// watch:{
	//     async $route(){
	//         this.hasFormId=false;
	//         await this.$nextTick();
	//         this.hasFormId=true;

	//     }
	// },
	// data(){
	//     return {
	//         hasFormId:true
	//     }
	// }

	//  computed: {
	//     ...mapGetters({
	//         inventoryForms:[InventoryFormGetters.INVENTORY_FORMS],

	//     }),
	//     currentInventoryFormId() {
	//         return this.$route.params.id;
	//     }
	// },
	// watch: {
	//     currentInventoryFormId : function () {
	//         this.loadInventoryForm();
	//     }
	// },
	// created() {
	//     this.loadInventoryForm();
	// },
	// destroyed() {

	// },
	// methods:{
	//     loadInventoryForm(){

	//     },

	// },
};
</script>
